import { PaymentLimitsActionType } from './actions';
const reducer = (state, action) => {
    switch (action.type) {
        case PaymentLimitsActionType.SET_MAX_TRANSACTION_AMOUNT:
            return {
                ...state,
                maxTransactionAmount: action.payload,
            };
        case PaymentLimitsActionType.SET_MAX_MONTHLY_TRANSACTION_AMOUNT:
            return {
                ...state,
                maxMonthlyTransactionAmount: action.payload,
            };
        case PaymentLimitsActionType.SET_BANK_LIMITS:
            return {
                ...state,
                bankLimits: action.payload,
            };
        default:
            return state;
    }
};
const paymentLimitReducer = (state, action) => {
    const newState = reducer(state, action);
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('%cUpdate payment limit form', 'color: green; font-weight: bold', action, 'new state', newState);
    }
    return newState;
};
export default paymentLimitReducer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVkdWNlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy93aWRnZXRzL1VwZGF0ZVBheW1lbnRMaW1pdHMvZm9ybS9yZWR1Y2VyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBdUIsdUJBQXVCLEVBQUUsTUFBTSxXQUFXLENBQUM7QUFHekUsTUFBTSxPQUFPLEdBQUcsQ0FBQyxLQUF5QixFQUFFLE1BQTJCLEVBQXNCLEVBQUU7SUFDM0YsUUFBUSxNQUFNLENBQUMsSUFBSSxFQUFFLENBQUM7UUFDbEIsS0FBSyx1QkFBdUIsQ0FBQywwQkFBMEI7WUFDbkQsT0FBTztnQkFDSCxHQUFHLEtBQUs7Z0JBQ1Isb0JBQW9CLEVBQUUsTUFBTSxDQUFDLE9BQU87YUFDdkMsQ0FBQztRQUNOLEtBQUssdUJBQXVCLENBQUMsa0NBQWtDO1lBQzNELE9BQU87Z0JBQ0gsR0FBRyxLQUFLO2dCQUNSLDJCQUEyQixFQUFFLE1BQU0sQ0FBQyxPQUFPO2FBQzlDLENBQUM7UUFDTixLQUFLLHVCQUF1QixDQUFDLGVBQWU7WUFDeEMsT0FBTztnQkFDSCxHQUFHLEtBQUs7Z0JBQ1IsVUFBVSxFQUFFLE1BQU0sQ0FBQyxPQUFPO2FBQzdCLENBQUM7UUFDTjtZQUNJLE9BQU8sS0FBSyxDQUFDO0lBQ3JCLENBQUM7QUFDTCxDQUFDLENBQUM7QUFFRixNQUFNLG1CQUFtQixHQUFHLENBQUMsS0FBeUIsRUFBRSxNQUEyQixFQUFzQixFQUFFO0lBQ3ZHLE1BQU0sUUFBUSxHQUFHLE9BQU8sQ0FBQyxLQUFLLEVBQUUsTUFBTSxDQUFDLENBQUM7SUFDeEMsSUFBSSxPQUFPLENBQUMsR0FBRyxDQUFDLFFBQVEsS0FBSyxhQUFhLEVBQUUsQ0FBQztRQUN6QyxzQ0FBc0M7UUFDdEMsT0FBTyxDQUFDLEdBQUcsQ0FBQyw2QkFBNkIsRUFBRSxpQ0FBaUMsRUFBRSxNQUFNLEVBQUUsV0FBVyxFQUFFLFFBQVEsQ0FBQyxDQUFDO0lBQ2pILENBQUM7SUFDRCxPQUFPLFFBQVEsQ0FBQztBQUNwQixDQUFDLENBQUM7QUFFRixlQUFlLG1CQUFtQixDQUFDIn0=